import * as React from "react";
import AccountAddValidation from "./components/containers/modals/AccountAddValidation";
import AuthIndividual from "./components/containers/modals/AuthIndividual";
import AuthIndividualAdd from "./components/containers/modals/AuthIndividualAdd";
import Modal from "./components/presentational/Modal";
import PasswordForgotInitial from "./components/containers/modals/PasswordForgotInitial";
import RelationshipEdit from "./components/containers/modals/RelationshipEdit";
import Timeout from "./components/containers/modals/Timeout";
/* tslint:disable:jsx-wrap-multiline */
export default function renderModals(props) {
    const modals = [
        <Modal key="authIndividual" id="authIndividual" label="Authorized Individual">
			<AuthIndividual />
		</Modal>,
        <Modal key="authIndividualAdd" id="authIndividualAdd" label="Authorized Individual">
			<AuthIndividualAdd />
		</Modal>,
        <Modal key="forgotPassword" id="forgotPassword" label="Forgot Password">
			<PasswordForgotInitial />
		</Modal>,
        <Modal key="validateAddAccount" id="validateAddAccount" label="Account Validation">
			<AccountAddValidation />
		</Modal>,
        <Modal key="editRelationship" id="editRelationship" label="Edit Relationship">
			<RelationshipEdit />
		</Modal>,
        <Modal key="sessionTimeout" id="sessionTimeout" label="Session Timeout" onCloseCallback={props.onExtendSession}>
			<Timeout />
		</Modal>
    ];
    return modals;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/renderModals.tsx